export enum NoteType {
	NA = '',
	Revision = 'revision',
	Annotation = 'annotation'
}
